import './app';
import './bettingArea/luckyXBettingArea';
import './luckyXController';
import './luckyXUi';
import './luckyXUiService';
import './results/luckyXResultsController';
import './results/luckyXResultsDrv';

export default 'terminalApp.nabLuckyXUi';
